import LazyLoadImagesHelper from '@/helpers/global/lazyLoadImages.helper';

class AccordionsHelper {
  initContentBuilderAccordionsLogic() {
    const accordionsList = document.querySelectorAll('.row.cb-accordion');

    accordionsList.forEach((accordion) => {
      const accordionHeader = accordion.querySelector('.cb-accordion-header');
      const accordionBody = accordion.querySelector('.cb-accordion-body');
      accordionHeader.addEventListener('click', () => {
        if (accordionHeader.classList.contains('active')) {
          accordionHeader.classList.remove('active');
          accordionBody.classList.remove('active');
          accordionBody.style.height = '0px';
        } else {
          const openAccordion = () => {
            accordionHeader.classList.remove('loading');

            accordionHeader.classList.add('active');
            accordionBody.classList.add('active');
            const accordionBodyHeight = accordionBody.querySelector('.cb-accordion-body-content').clientHeight;
            accordionBody.style.height = `${accordionBodyHeight + 2}px`;
          };

          accordionHeader.classList.add('loading');

          let checkAccordionBodyInterval = null;

          const accordionBodyImages = accordionBody.querySelectorAll('img.lazy');
          let accordionBodyImagesLoaded = accordionBody.querySelectorAll('img.lazy.loaded');

          if (accordionBodyImages.length !== accordionBodyImagesLoaded.length) {
            if (accordionBodyImages.length > 0) {
              accordionBodyImages.forEach((image: HTMLElement) => {
                LazyLoadImagesHelper.loadImagesInElement(image);
              });
            }

            checkAccordionBodyInterval = setInterval(() => {
              accordionBodyImagesLoaded = accordionBody.querySelectorAll('img.lazy.loaded');

              if (accordionBodyImages.length === accordionBodyImagesLoaded.length) {
                clearInterval(checkAccordionBodyInterval);
                openAccordion();
              }
            }, 100);
          } else {
            openAccordion();
          }
        }
      });
    });
  }

  initGlobalAccordionsLogic() {
    const accordionsList = document.querySelectorAll('.accordion, .cb-accordion');

    accordionsList.forEach((accordion) => {
      if (accordion.classList.contains('initialized')) return;

      const accordionHeader = accordion.querySelector('.accordion-header, .cb-accordion-header') as HTMLElement;
      const accordionBody = accordion.querySelector('.accordion-body, .cb-accordion-body') as HTMLElement;
      const accordionBodyContent = accordion.querySelector('.accordion-body-content, .cb-accordion-body-content') as HTMLElement;

      if (!accordionHeader || !accordionBody || !accordionBodyContent) return;

      const getContentHeight = (element: HTMLElement): number => {
        return element.offsetHeight;
      };

      const updateParentAccordionHeights = (startElement: HTMLElement) => {
        let currentElement = startElement;
        let parentAccordion = currentElement
          .closest('.accordion, .cb-accordion')
          ?.parentElement?.closest('.accordion, .cb-accordion') as HTMLElement | null;

        while (parentAccordion) {
          const parentBody = parentAccordion.querySelector('.accordion-body, .cb-accordion-body') as HTMLElement;
          const parentContent = parentAccordion.querySelector('.accordion-body-content, .cb-accordion-body-content') as HTMLElement;

          if (!parentBody || !parentBody.classList.contains('active')) break;

          const parentContentHeight = getContentHeight(parentContent);

          const totalHeight = parentContentHeight;

          parentBody.style.height = `${totalHeight}px`;

          currentElement = parentAccordion;
          parentAccordion = parentAccordion
            .closest('.accordion, .cb-accordion')
            ?.parentElement?.closest('.accordion, .cb-accordion') as HTMLElement | null;
        }
      };

      const initialContentHeight = getContentHeight(accordionBodyContent);

      if (accordionBody.classList.contains('active')) {
        const originalTransition = accordionBody.style.transition;
        accordionBody.style.transition = 'none';
        accordionBody.style.height = `${initialContentHeight + 2}px`;
        void accordionBody.offsetWidth;
        accordionBody.style.transition = originalTransition;

        setTimeout(() => {
          updateParentAccordionHeights(accordion);
        }, 0);
      } else {
        accordionBody.style.height = '0px';
      }

      accordionHeader.addEventListener('click', (event: Event) => {
        if (accordionHeader.classList.contains('open-on-button-click') && !(event.target as HTMLElement).classList.contains('accordion-button')) {
          return;
        }

        const isActive = accordionBody.classList.contains('active');
        accordionHeader.classList.toggle('active', !isActive);
        accordionBody.classList.toggle('active', !isActive);

        if (!isActive) {
          const contentHeight = getContentHeight(accordionBodyContent);

          accordionBody.style.height = `${contentHeight + 2}px`;

          requestAnimationFrame(() => {
            updateParentAccordionHeights(accordion);
          });
        } else {
          requestAnimationFrame(() => {
            accordionBody.style.height = '0px';
            updateParentAccordionHeights(accordion);
          });
        }
      });

      const contentObserver = new MutationObserver(() => {
        if (accordionBody.classList.contains('active')) {
          const contentHeight = getContentHeight(accordionBodyContent);
          accordionBody.style.height = `${contentHeight + 2}px`;

          requestAnimationFrame(() => {
            updateParentAccordionHeights(accordion);
          });
        }
      });

      contentObserver.observe(accordionBodyContent, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      const resizeObserver = new ResizeObserver(() => {
        if (accordionBody.classList.contains('active')) {
          const contentHeight = getContentHeight(accordionBodyContent);
          accordionBody.style.height = `${contentHeight + 2}px`;

          requestAnimationFrame(() => {
            updateParentAccordionHeights(accordion);
          });
        }
      });

      resizeObserver.observe(accordionBodyContent);

      accordion.classList.add('initialized');
    });
  }
}

export default new AccordionsHelper();
